import { render, staticRenderFns } from "./FoodModal.vue?vue&type=template&id=50096574&scoped=true"
import script from "./FoodModal.vue?vue&type=script&lang=js"
export * from "./FoodModal.vue?vue&type=script&lang=js"
import style0 from "./FoodModal.vue?vue&type=style&index=0&id=50096574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50096574",
  null
  
)

export default component.exports